
import React from "react"
import styled from 'styled-components'
import useClipboard from "react-use-clipboard";

export default function Contact({ isBgTransparent = false }) {
  const [isCopied, setIsCopied] = useClipboard("zremboldt@gmail.com", {
    // `isCopied` will go back to `false` after 3000ms.
    successDuration: 3000,
  });

  return (
    <ContactLayout>
      <Wrap>
        <Container isBgTransparent={isBgTransparent}>
          <Left>
            <span>Say hello!</span>
            <span className={'hand'}>👋</span>
          </Left>
          <Right onClick={() => setIsCopied()}>
            <TextContainer isCopied={isCopied}>
              <p>zremboldt@gmail.com</p>
              <p>Address copied!</p>
            </TextContainer>
          </Right>
        </Container>
      </Wrap>
    </ContactLayout>
  )
}
const ContactLayout = styled.div`
  display: flex;
  justify-content: center;
  `
const Wrap = styled.div`
  position: fixed;
  z-index: 10;
  top: 0;
  width: min(1200px, 100vw);
  display: flex;
  justify-content: flex-end;
  height: 0px;
  `
const Container = styled.div`
  position: absolute;
  top: 3rem;
  margin: 0 1.9rem;
  display: flex;
  height: 6rem;
  border-radius: 16px;
  border: 1px solid var(--resume-border-color);
  overflow-y: hidden;
  ${({ isBgTransparent }) => (
    isBgTransparent ? (`
    background-color: hsla(235, 40%, 20%, 0.5);
    backdrop-filter: blur(10px);
    `) : (`
    background-color: hsla(216, 45%, 7%, 0.9);
    backdrop-filter: blur(4px);
    `)
  )}
  & .hand {
    color: initial;
    display: inline-block;
    font-size: 18px;
  }
  &:hover .hand {
    animation-name: wave-animation;
    animation-duration: 2.5s;
    animation-iteration-count: infinite;
    transform-origin: 70% 70%;
    @keyframes wave-animation {
      0% { transform: rotate( 0.0deg) scale(1) }
      10% { transform: rotate(14.0deg) scale(1.2) }
      20% { transform: rotate(-8.0deg) scale(1.2) }
      30% { transform: rotate(14.0deg) scale(1.2) }
      40% { transform: rotate(-4.0deg) scale(1.2) }
      50% { transform: rotate(10.0deg) scale(1.2) }
      60% { transform: rotate( 0.0deg) scale(1) }
      100% { transform: rotate( 0.0deg) scale(1) }
    }
  }
  @media (max-width: 560px) {
    top: 1rem;
    left: 0;
    margin: 0 2rem;
    width: calc(100vw - 4rem);
  }
`
const Left = styled.div`
  height: 100%;
  display: flex;
  padding: 1.6rem 2.6rem;
  border-right: 1px solid var(--section-border-color);
  pointer-events: none;
  & > span:first-of-type {
    display: none;
    @media (min-width: 420px) {
      display: block;
      margin-right: 6px;
    }
  }
`
const Right = styled.button`
  flex: 1;
  appearance: none;
  border: none;
  background-color: transparent;
  height: 100%;
  cursor: pointer;
  transition: background-color 200ms var(--ease-out-quart);
  outline: none;
  &:hover > div > p, &:focus > div > p {
    color: white;
  }
  &:hover, &:focus {
    background-color: hsla(240, 100%, 70%, 0.07);
  }
`
const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  height: 12rem;
  text-align: center;
  transition: transform 400ms var(--ease-out-back);
  transform: ${({ isCopied }) => isCopied ? `translateY(-6rem)` : `translateY(0rem)`};
  & > p {
    margin-bottom: 5px;
    padding: 0rem 2.6rem;
    transition: color 200ms var(--ease-out-quart);
  }
`
